import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { X, Loader2, MailCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const apiError = (err) => {
  const d = err.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return 'Informe um e-mail válido';
  return 'Não foi possível enviar agora. Tente novamente.';
};

export const ForgotPasswordLink = ({ kind, color = '#68AAB0' }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="forgot-password-link"
        style={{ background: 'none', border: 'none', color, fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer', padding: '0.25rem 0', marginTop: '0.5rem' }}>
        Esqueci minha senha
      </button>
      {open && createPortal(<ForgotPasswordModal kind={kind} onClose={() => setOpen(false)} />, document.getElementById('root') || document.body)}
    </>
  );
};

const ForgotPasswordModal = ({ kind, onClose }) => {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setError(''); setSending(true);
    try {
      const { data } = await axios.post(`${API}/auth/forgot-password`, { email: email.trim(), kind });
      setSent(data.message);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 7000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <form onClick={(e) => e.stopPropagation()} onSubmit={submit} data-testid="forgot-password-modal"
        style={{ background: 'white', borderRadius: 14, padding: '1.5rem', width: '100%', maxWidth: 400, textAlign: 'left' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
          <h3 style={{ fontWeight: 700, color: '#2D3748' }}>Esqueci minha senha</h3>
          <button type="button" onClick={onClose} data-testid="forgot-password-close" style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X className="w-5 h-5" /></button>
        </div>
        {sent ? (
          <div data-testid="forgot-password-sent" style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start', color: '#2f855a', fontSize: '0.9rem', lineHeight: 1.5 }}>
            <MailCheck className="w-6 h-6" style={{ flexShrink: 0 }} />
            <span>{sent} Verifique também a caixa de spam.</span>
          </div>
        ) : (
          <>
            <p style={{ fontSize: '0.85rem', color: '#718096', marginBottom: '1rem' }}>Informe o e-mail da sua conta. Enviaremos um link para você criar uma nova senha.</p>
            {error && <p data-testid="forgot-password-error" style={{ color: '#c53030', fontSize: '0.85rem', marginBottom: '0.75rem' }}>{error}</p>}
            <Label htmlFor="forgot-email">E-mail</Label>
            <Input id="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seu@email.com" data-testid="forgot-password-email" />
            <Button type="submit" disabled={sending} style={{ width: '100%', marginTop: '1.25rem', background: '#68AAB0' }} data-testid="forgot-password-submit">
              {sending && <Loader2 className="w-4 h-4 animate-spin mr-2" />}Enviar link
            </Button>
          </>
        )}
      </form>
    </div>
  );
};
